var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08 6.75H3.42V8H2.08V6.75ZM0.49 3.13C0.49 2.76333 0.543333 2.43 0.65 2.13C0.763333 1.83 0.923333 1.57333 1.13 1.36C1.34333 1.14667 1.59667 0.983333 1.89 0.869999C2.19 0.75 2.52333 0.69 2.89 0.69C3.19667 0.69 3.48 0.736667 3.74 0.83C4.00667 0.916666 4.23667 1.04667 4.43 1.22C4.63 1.38667 4.78667 1.59667 4.9 1.85C5.01333 2.10333 5.07 2.39 5.07 2.71C5.07 2.94333 5.04333 3.14667 4.99 3.32C4.94333 3.48667 4.87667 3.63333 4.79 3.76C4.71 3.88 4.61667 3.99 4.51 4.09C4.40333 4.18333 4.29667 4.27667 4.19 4.37C4.06333 4.47667 3.94667 4.58 3.84 4.68C3.73333 4.78 3.64 4.89333 3.56 5.02C3.48 5.14 3.41667 5.28333 3.37 5.45C3.33 5.61667 3.31 5.82 3.31 6.06H2.23C2.23 5.76667 2.24333 5.52 2.27 5.32C2.30333 5.11333 2.35333 4.93333 2.42 4.78C2.48667 4.62667 2.56667 4.49333 2.66 4.38C2.76 4.26 2.87667 4.14333 3.01 4.03C3.11667 3.93667 3.21667 3.85 3.31 3.77C3.41 3.69 3.49667 3.60333 3.57 3.51C3.65 3.41 3.71 3.3 3.75 3.18C3.79667 3.06 3.82 2.91667 3.82 2.75C3.82 2.55 3.78333 2.38 3.71 2.24C3.64333 2.09333 3.56 1.97667 3.46 1.89C3.36 1.80333 3.25333 1.74 3.14 1.7C3.02667 1.66 2.92667 1.64 2.84 1.64C2.42667 1.64 2.12 1.77667 1.92 2.05C1.72667 2.31667 1.63 2.67667 1.63 3.13H0.49Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionSmall);
export default __webpack_public_path__ + "static/media/questionSmall.db79e55aa3be1460873abec7dd984da6.svg";
export { ForwardRef as ReactComponent };